var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"broker-lead-view"},[_c('v-row',[_c('v-col',{attrs:{"md":"12"}},[_c('lead-table')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }